import { useEffect, useState } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

import Login from "./Pages/Login/Login";
import Home from "./Pages/Home/Home";
import { User } from "./Utils/Types";

const App = () => {
	const [authenticatedUser, setAuthenticatedUser] = useState<User | null>(null);
	const [isUserAuthenticated, setUserIsAuthenticated] =
		useState<boolean>(false);

	useEffect(() => {
		if (sessionStorage.getItem("isAuthenticated") === "true") {
			setUserIsAuthenticated(true);
			const user = sessionStorage.getItem("authenticatedUser");
			if (user && user !== "") setAuthenticatedUser(JSON.parse(user));
		} else setUserIsAuthenticated(false);
	}, []);

	return (
		<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
			{!isUserAuthenticated ? (
				<Login
					authenticatedUser={authenticatedUser}
					setAuthenticatedUser={setAuthenticatedUser}
					setUserIsAuthenticated={setUserIsAuthenticated}
				/>
			) : (
				<Home
					authenticatedUser={authenticatedUser}
					setAuthenticatedUser={setAuthenticatedUser}
					setUserIsAuthenticated={setUserIsAuthenticated}
				/>
			)}
		</GoogleOAuthProvider>
	);
};

export default App;
